import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface PostState {
  posts: any[];
  currentPage: number;
  hasMore: boolean;
  loading: boolean;
}

const initialState: PostState = {
  posts: [],
  currentPage: 1,
  hasMore: true,
  loading: false,
};

const PostSlice = createSlice({
  name: 'post',
  initialState,
  reducers: {
    setPosts: (state, action: PayloadAction<any[]>) => {
      state.posts = action.payload;
      state.currentPage = 1;
      state.hasMore = action.payload.length > 0;
    },
    appendPosts: (state, action: PayloadAction<any[]>) => {
      const existingIds = new Set(state.posts.map(post => post._id || post.id));
      const uniqueNewPosts = action.payload.filter(post => !existingIds.has(post._id || post.id));
      state.posts = [...state.posts, ...uniqueNewPosts];
      state.currentPage += 1;
      state.hasMore = action.payload.length > 0;
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    resetPosts: (state) => {
      state.posts = [];
      state.currentPage = 1;
      state.hasMore = true;
      state.loading = false;
    },
    editPost: (state, action: PayloadAction<any>) => {
      state.posts = state.posts.map(post => post.id === action.payload.id ? action.payload : post);
    },
    deletePost: (state, action: PayloadAction<any>) => {
      state.posts = state.posts.filter(post => post._id !== action.payload);
    },
    updatePost: (state, action: PayloadAction<any>) => {
      state.posts = state.posts.map(post => {
        const id = action.payload._id || action.payload.postId;
        if (post._id === id) {
          return { ...post, ...action.payload };
        }
        return post;
      });
    },
  },
});

export const { setPosts, appendPosts, setLoading, resetPosts, editPost, deletePost, updatePost } = PostSlice.actions;
export default PostSlice.reducer;
